/**
 * Redesign FAQ Article Container.
 * To display FAQ content for article route
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _filter from 'lodash/filter';
import _isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import Loader from 'kepler/lib/components/Loader';
import { bindActionCreators } from 'redux';

// Components
import Article from '../../contactUs/components/Article';
import RelatedArticles from '../../contactUs/components/RelatedArticles';
import FAQFeedback from '../components/FAQFeedback';
import ErrorPanel from '../components/ErrorPanel';
import ToggleComponent from '../components/ToggleComponent';
import AriaTooltipComponent from '../../contactUs/components/common/tooltipComponent/AriaTooltipComponent';


// Container
import ContentToggle from './ContentToggle';

// Constants
import * as shape from '../../contactUs/constants/PropTypesShapes';
import * as homeShape from '../constants/PropTypesShapes';

// Actions
import { receiveArticleError } from '../../contactUs/actions/action-article';
import { toggleRelated } from '../../contactUs/actions/action-content-toggle';

// Content toggle Constants Data
import { labels } from '../constants/contentToggleData';
import Breadcrumb from '../containers/Breadcrumb';
import { updateBreadcrumb } from '../actions/action-breadcrumb';

// Helpers
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import { trackLink } from '../../lib/analytics-helper';
import CaseSection from '../components/CaseSection';

// Const Data Set
const cobrand = Page.getCountry();
const exp = Page.getUserExperience();
const articleURL = `/${cobrand}/smarthelp/article/`;
const isLoggedIn = Page.isLoggedIn();
const relatedTopics = i18n.message('smarthelp/channelSelection.upfrontFaq.relatedArticle');

// Content Toggle exp
const userExp = ['personal', 'business'];
const machineMarket = {
  localized: Page.getMachineTranslationMarket(),
  origin: 'en_US',
};

class ArticlePanel extends Component {
  // render content toggle to switch
  static renderContentToggle(display) {
    // The Content Toggle is only for Logged out user
    const faqLabel = {
      desktop: labels.mobile,
      mobile: labels.mobile,
    };
    return (
      <div className="article-content-toggle-container">
        <ContentToggle userExpClass={userExp} display={display} labels={faqLabel} FPTIPageName={'articlePage'} hashAnchor />
      </div>
    );
  }

  // render Article Error Page
  static renderErrorPage() {
    return <ErrorPanel />;
  }

  constructor(props) {
    super(props);
    this.state = {
      isToolTipTouched: false,
      locale: machineMarket.origin,
      translated: false,
      translationError: false,
      isLoggedIn: document.body.getAttribute('isloggedin'),
    };

    this.clickTranslatedHandler = this.clickTranslatedHandler.bind(this);
  }

  // get Article FPTI link
  getFPTILink() {
    if (this.props.article && this.props.article.articleId) {
      return `smarthelp-article-page|${exp}|${this.props.article.articleId}`;
    }
    return `smarthelp-article-page|${exp}`;
  }

  // Get article Content with content toggle exp or Logged in user exp
  getArticleContent() {
    const articleContent = {
      personal: this.props.article.consumerContent || '',
      premier: this.props.article.consumerContent || '',
      business: this.props.article.merchantContent || '',
      technical: this.props.article.merchantContent || '',
    };

    if (this.displayContentToggle()) {
      // Using content toggle switched exp to display content
      return articleContent[this.props.exp];
    }

    // Display Merchant article content for technical experience
    if (Page.isTechnicalExp() && articleContent.technical) {
      return articleContent.technical;
    }

    // Check MTS article info; MTS article only display business content without content toggle
    if (this.props.article && Page.isMTSArticle(this.props.article.articleId) && articleContent.business) {
      return articleContent.business;
    }

    // Display either Personal or Business article content
    if (articleContent[exp]) {
      return articleContent[exp];
    } else if ((exp === 'personal' || exp === 'premier') && articleContent.business) {
      return articleContent.business;
    } else if (exp === 'business' && articleContent.personal) {
      return articleContent.personal;
    }

    // Will show error page only if receiving Neither personal nor business article content
    // To display Error page for no article content with current experience
    this.props.receiveArticleError();

    return null;
  }

  // Get Machine translation tooltip message
  getTooltipMsg() {
    return Page.getTooltip(this.getMarketWillToggle());
  }

  // Get article content between Machie translated content and origin English Content
  getArticleSwitch() {
    if (this.state.translated && this.hasMachineTranslatedArticle()) {
      return this.props.machineArticle.article && this.props.machineArticle.article.articleContent;
    }
    return this.getArticleContent();
  }

  getMarketWillToggle() {
    return this.state.locale === machineMarket.origin ? machineMarket.localized : machineMarket.origin;
  }

  // Check Machine Translated article content whether is ready or not
  hasMachineTranslatedArticle() {
    return (!this.props.machineArticle.isLoading && !this.props.machineArticle.error && !_isEmpty(this.props.machineArticle.article));
  }

  trackTooltip() {
    if (this.state.isToolTipTouched === false) {
      trackLink({
        id: 'articlePage',
        link: 'smarthelp-tooltip',
      });
    }

    this.setState({
      isToolTipTouched: true,
    });
  }

  // parse Article with article content and id
  parseArticle() {
    return {
      articleContent: this.getArticleSwitch(),
      articleId: this.props.article.articleId,
    };
  }

  /** Content Toggle Display logic:
   * Do not display for Logged in Users
   * Do not display when there is no content for both merchant and consumer
   * Do not display when the merchant is the same with consumer content
   * Do not display for technical experience
   */
  displayContentToggle() {
    if (!isLoggedIn && this.props.article.consumerContent !== this.props.article.merchantContent && !Page.isTechnicalExp()) {
      if (this.props.article.consumerContent && this.props.article.merchantContent) {
        return true;
      }
    }
    return false;
  }

  // filter out the related article have the same title with article title
  relatedArticleFilter() {
    const articleIdtmp = this.props.article && this.props.article.articleId;
    return _filter(this.props.relatedArticles, relatedArticle => (
      articleIdtmp !== relatedArticle.articleId
    ));
  }

  // Check Community results
  hasCommunityResult() {
    return this.props.community && !this.props.community.error && this.props.community.results.length > 0;
  }

  // Show technical breadcrumb only for technical experience
  isShowTechnicalBreadcrumb() {
    const isTSArticle = Page.isMTSArticle(this.props.article.articleId);
    return (isTSArticle && Page.isTechnicalExp()) || !isTSArticle;
  }

  displayRelatedToggle() {
    // Display relate toggle, when both related title and community post has data
    return this.relatedArticleFilter().length > 0 && this.hasCommunityResult();
  }

  // FPTI event for Machine Translation button clicking
  clickFPTITracker() {
    trackLink({
      id: 'articlePage',
      link: `smarthelp-machine-translation|toggle|${this.getMarketWillToggle()}`,
    });
  }

  clickTranslatedHandler() {
    this.clickFPTITracker();

    if (!this.hasMachineTranslatedArticle()) {
      return this.setState({ translationError: true });
    } else if (!this.state.translated) {
      return this.setState({ translated: true, locale: this.getMarketWillToggle() });
    }
    return this.setState({ translated: false, locale: this.getMarketWillToggle() });
  }


  renderTooltip(tooltipData) {
    if (tooltipData) {
      return (<span className="translation-tooltip-container">
        <AriaTooltipComponent
          message={tooltipData}
          direction="top"
          tooltipContentPosition={{ x: -63, y: -112 }}
          afterHide={() => this.trackTooltip()}
        >
          <button><span className="vx_icon vx_icon-small vx_icon-tooltip-small" /></button>
        </AriaTooltipComponent>
      </span>
      );
    }
    return null;
  }

  renderTranslateButton() {
    if (this.state.translationError) {
      return (<div className="translation-error">
        {Page.getTranslationError(machineMarket.localized)}
      </div>);
    }

    return (
      <div className="traslate-button-container">
        <button
          className="translate-button"
          onClick={this.clickTranslatedHandler}
        >
          {Page.getTranslation(this.getMarketWillToggle())}
        </button>
        {this.renderTooltip(this.getTooltipMsg())}
      </div>);
  }

  renderContent(tabSelected) {
    const showCommuity = this.relatedArticleFilter().length <= 0 && this.hasCommunityResult();

    if (tabSelected === 'ErrorRelated' || tabSelected === 'community' || showCommuity) {
      return this.renderRelatedSection(this.props.community.results, true, undefined, '_blank', 'smarthelp-community-posts');
    }
    return this.renderRelatedSection(this.relatedArticleFilter(), false, articleURL, '_self', 'smarthelp-related-articles');
  }
  // Render Related Tab Content
  renderRelatedSection(articles, isCommunity, url, target, link) {
    const displayNumber = 5;
    const upfrontFAQId = `|${this.props.article.articleId}` || '';
    const relatedTopicAttribs = {
      className: 'related-topics-body',
      role: 'tabpanel',
      tabIndex: '0',
      'aria-selected': true,
    };

    return (
      <div {...relatedTopicAttribs}>
        <RelatedArticles
          relatedArticles={articles}
          displayNumber={displayNumber}
          upfront={upfrontFAQId}
          FPTIPageName="articlePage"
          target={target}
          relatedRedirectURL={url}
          community={isCommunity}
          link={link}
        />
      </div>
    );
  }

  renderCaseSection() {
    return Page.isResTitleEnable() ? (
      <CaseSection
        cases={this.props.openCase}
        elmoTreatment={this.props.elmoTreatment}
        receivedResponse={this.props.receivedResponse}
        articleId={this.props.article.articleId}
        articleBreadCrumb={this.props.article.breadCrumbPath}
      />
    ) : null;
  }

  renderArticleTitle() {
    let articleTitle = this.props.article.articleTitle;
    // Switch article title for MT Translated content
    if (this.state.translated && this.hasMachineTranslatedArticle()) {
      articleTitle = this.props.machineArticle.article && this.props.machineArticle.article.articleTitle;
    }
    return (<h1 className="article-title">{articleTitle}</h1>);
  }

  // Render Article
  renderArticle() {
    // Loader for loadin article
    if (this.props.isLoading) {
      return <Loader show type="fixed" />;
    }
    // Page.setDocumentTitle(options);
    Page.setDocumentTitle(this.props.article.articleTitle);

    // Seperating title to add content toggle between header and content
    return (
      <div className="article-content">
        {this.renderCaseSection()}
        {this.renderArticleTitle()}
        {this.renderTranslate()}
        {ArticlePanel.renderContentToggle(this.displayContentToggle())}
        <Article article={this.parseArticle()} pageName="articlePage" />
      </div>
    );
  }

  renderRelatedTopicsPanel() {
    if (this.relatedArticleFilter().length <= 0 && !this.hasCommunityResult()) {
      return null;
    }
    return (
      <div className="related-topics-content">
        <h2 className="related-topics-heading">{relatedTopics}</h2>
        <ToggleComponent clickHandler={this.props.toggleRelated} display={this.displayRelatedToggle()} />
        {this.renderContent(this.props.tab)}
      </div>
    );
  }

  // render breadcrumb if the breadcrumb data is validate
  renderBreadcrumb() {
    if (Array.isArray(this.props.breadcrumb) && this.props.breadcrumb.length > 0 && this.isShowTechnicalBreadcrumb()) {
      return <Breadcrumb items={this.props.breadcrumb} action={this.props.updateBreadcrumb} />;
    }
    return null;
  }

  // Render Machine translation Button or Error message
  renderTranslate() {
    if (Page.isMachineTranslation() && Page.getTranslation(this.state.locale)) {
      return this.renderTranslateButton();
    }
    return null;
  }

  // adding refund tracker based on breadcrumb path
  // Refund tracker mounting identifier; check FAQ in the Remote Config or FAQ is under refund topic
  renderRefundHelp() {
    if (!this.props.article || !this.props.article.articleId || !(Page.hasRefundHelpFaq(this.props.article.articleId) || Page.isUnderRefundFaq(this.props.article.breadCrumbPath))) {
      return null;
    }

    return <div id="refund-help" name="article" />;
  }

  render() {
    if (this.props.error) {
      return ArticlePanel.renderErrorPage();
    }
    return (
      <div className="article-panel-container">
        {this.renderRefundHelp()}
        {this.renderBreadcrumb()}
        {this.renderArticle()}
        <FAQFeedback
          FPTILink={this.getFPTILink()}
          articleId={this.props.article.articleId}
          exp={exp}
          contactSwitch={this.props.exp}
        />
        {this.renderRelatedTopicsPanel()}
      </div>
    );
  }
}

ArticlePanel.propTypes = {
  article: PropTypes.shape(shape.FAQ_ARTICLE),
  machineArticle: PropTypes.shape(homeShape.MACHINE_ARTICLE),
  relatedArticles: PropTypes.arrayOf(PropTypes.shape(shape.FAQ_RELATED_ARTICLE)),
  isLoading: PropTypes.bool,
  error: PropTypes.bool,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape(shape.BREADCRUMB_ITEM)),
  updateBreadcrumb: PropTypes.func.isRequired,
  receiveArticleError: PropTypes.func.isRequired,
  toggleRelated: PropTypes.func.isRequired,
  exp: PropTypes.string,
  community: PropTypes.shape(homeShape.COMMUNITY).isRequired,
  tab: PropTypes.string,
  openCase: PropTypes.shape(homeShape.OPEN_CASE).isRequired,
  elmoTreatment: PropTypes.shape(homeShape.ELMO_TREATMENT).isRequired,
  receivedResponse: PropTypes.bool.isRequired,
};

ArticlePanel.defaultProps = {
  article: {},
  machineArticle: {},
  relatedArticles: [],
  isLoading: false,
  error: false,
  exp: '',
  breadcrumb: [],
  tab: '',
  elmoTreatment: [],
};

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    article: state.article.article,
    relatedArticles: state.article.relatedArticles,
    machineArticle: state.machineArticle,
    isLoading: state.article.isLoading,
    error: state.article.error,
    articleList: state.articleList,
    breadcrumb: state.breadcrumb.items,
    exp: state.contentToggle.experience,
    community: state.community,
    tab: state.contentToggle.tab,
    openCase: state.openCase.cases,
    elmoTreatment: state.app.elmoTreatments,
    receivedResponse: state.app.receivedResponse,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ updateBreadcrumb, receiveArticleError, toggleRelated }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticlePanel);
